import { render, staticRenderFns } from "./Referrals.vue?vue&type=template&id=22586bbe"
import script from "./Referrals.ts?vue&type=script&lang=js&external"
export * from "./Referrals.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports